
import { Component, Vue, Mixins, Prop } from 'vue-property-decorator'
import Chart from '../../mixins/Chart.vue'
import { Dataset, Options } from '../../@types/Slide'

@Component
export default class Bubble extends Mixins<Chart>(Chart) {
  /**
   * Chart type.
   */
  public readonly chartType: string = 'bubble'
}
